<template>
  <div>
    <template v-if="isRoundLoading">
      <BaseLoading />
    </template>
    <template v-else-if="round">
      <TheRoundWidget
        :style="{ marginTop: '30px'}"
        :round="round"
        is-open-detail-button-hidden
      />

      <div
        class="d-flex justify-content-center py-4"
        :class="$style.navigationWrapper"
      >
        <router-link
          :to="{ name: 'round-history', params: { roundId: $route.params.roundId } }"
          class="mr-1"
        >
          <BaseButton
            :variant="$router.currentRoute.name === 'round-history' ? 'orange' : 'outline-orange'"
            font-size="small"
            left-rounded
          >
            <span class="px-2">{{ $t('past-matches') }}</span>
          </BaseButton>
        </router-link>

        <router-link :to="{ name: 'round-history-standings', params: { roundId: $route.params.roundId } }">
          <BaseButton
            :variant="$router.currentRoute.name === 'round-history-standings' ? 'orange' : 'outline-orange'"
            font-size="small"
            right-rounded
          >
            <span class="px-2">{{ $t('round-standings') }}</span>
          </BaseButton>
        </router-link>
      </div>

      <router-view />
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseLoading from '@/components/Atoms/BaseLoading'
import TheRoundWidget from '@/components/Organisms/TheRoundWidget'
import BaseButton from '@/components/Atoms/BaseButton'

export default {
  components: {
    BaseButton,
    TheRoundWidget,
    BaseLoading,
  },
  computed: {
    ...mapState({
      isRoundLoading: state => state['rounds/history/round'].isRoundLoading,
      round: state => state['rounds/history/round'].round,
    }),
  },
  mounted() {
    this.fetchRoundHistory({
      roundId: this.$route.params.roundId,
    }).then((round) => {
      if (this.$route.name === 'round-history-standings') {
        this.fetchScoreCounts({ roundId: this.$route.params.roundId }).then((ranks) => {
          ranks.map(({ score }) => this.fetchPlayersWithScore({ roundId: this.$route.params.roundId, score }))
        })
      }
      // @TODO: set active league and sport by round...
    })
  },
  methods: {
    ...mapActions({
      fetchRoundHistory: 'rounds/history/round/fetchRoundHistory',
      fetchScoreCounts: 'rounds/scoreCounts/fetchScoreCounts',
      fetchPlayersWithScore: 'rounds/scoreCounts/fetchPlayersWithScore',
    }),
  },
}
</script>

<style module lang="scss">
  @import "../../../assets/scss/variables";
  .navigationWrapper {
    background-color: $color-white;
    border-top: 1px solid $color-windswept-beach;
    border-bottom: 1px solid $color-windswept-beach;
  }
</style>
